import axios from "axios";
import { useEffect, useState } from "react";

const UseFetch = (url, option) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);
//   const localData = localStorage.getItem(url);
// console.log(JSON.parse(localData));

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // console.log(localData);
        
        // if (localData) {
        //   return JSON.parse(localData);
        // }
        const res = await axios({
          method: option.method,
          url: process.env.REACT_APP_SERVER_URL + url,
          data: option.details,
        });
        setData(res.data);
        setLoading(false);
        // // console.log(res.data);
        
        // localStorage.setItem(url, JSON.stringify(data)); // Save data to localStorage
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, [url]);

  return { data, loading, error };
};

export default UseFetch;
